var _path, _g, _g2, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgGiftCardEmpty(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 211,
    height: 179,
    viewBox: "0 0 211 179",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M106.08 160.304C147.481 160.304 181.045 126.74 181.045 85.191C181.045 43.6424 147.333 10.0781 106.08 10.0781C64.6789 10.0781 31.1147 43.6424 31.1147 85.191C31.1147 126.74 64.6789 160.304 106.08 160.304Z",
    fill: "#F3F1FC"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_6109_49188)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 32.5933,
    y: 34.8125,
    width: 144.903,
    height: 94.4382,
    rx: 11.8288,
    fill: "url(#paint0_linear_6109_49188)"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter1_d_6109_49188)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M40.5438 46.9701C44.124 49.0371 44.124 54.2046 40.5438 56.2716L23.5802 66.0655C20 68.1325 15.5248 65.5488 15.5248 61.4148L15.5248 41.8268C15.5248 37.6928 20 35.1091 23.5802 37.1761L40.5438 46.9701Z",
    fill: "url(#paint1_linear_6109_49188)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M46.7271 56.2711C43.147 54.2041 43.147 49.0366 46.7271 46.9697L63.6908 37.1757C67.2709 35.1087 71.7461 37.6924 71.7461 41.8264L71.7461 61.4144C71.7461 65.5484 67.2709 68.1321 63.6908 66.0651L46.7271 56.2711Z",
    fill: "url(#paint2_linear_6109_49188)"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M58.9447 71.5709C58.8782 71.6093 58.7962 71.6093 58.7297 71.5709L54.9336 69.3792C53.8596 68.7591 52.517 69.5342 52.517 70.7744L52.517 75.1579C52.517 75.2346 52.4761 75.3055 52.4096 75.3439C52.3069 75.4032 52.1756 75.368 52.1163 75.2653L41.5547 56.972C41.1098 56.2014 41.3738 55.2161 42.1443 54.7712L46.2611 52.3944C47.0317 51.9495 48.017 52.2135 48.4619 52.9841L59.0234 71.2772C59.0828 71.38 59.0475 71.5115 58.9447 71.5709Z",
    fill: "url(#paint3_linear_6109_49188)"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M27.3755 71.5709C27.442 71.6093 27.524 71.6093 27.5905 71.5709L31.3866 69.3792C32.4606 68.7591 33.8032 69.5342 33.8032 70.7744L33.8032 75.1579C33.8032 75.2346 33.8441 75.3055 33.9105 75.3439C34.0133 75.4032 34.1446 75.368 34.2039 75.2652L44.7656 56.972C45.2105 56.2014 44.9464 55.2161 44.1759 54.7712L40.0591 52.3944C39.2886 51.9495 38.3033 52.2135 37.8584 52.9841L27.2968 71.2772C27.2375 71.38 27.2727 71.5115 27.3755 71.5709Z",
    fill: "url(#paint4_linear_6109_49188)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 36.3185,
    y: 44.876,
    width: 13.5598,
    height: 13.5598,
    rx: 5.37021,
    fill: "#F7AD3C"
  }))), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M87.8843 90.02C89.9195 90.02 91.6416 88.3101 91.6416 86.2893C91.6416 84.2685 89.9195 82.5586 87.8843 82.5586C85.849 82.5586 84.1269 84.2685 84.1269 86.2893C84.1269 88.3101 85.849 90.02 87.8843 90.02Z",
    fill: "#15112D"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M119.9 91.73C121.935 91.73 123.657 90.02 123.657 87.9993C123.657 85.9785 121.935 84.2686 119.9 84.2686C117.865 84.2686 116.143 85.9785 116.143 87.9993C116.143 90.02 117.865 91.73 119.9 91.73Z",
    fill: "#15112D"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M113.168 97.9482H111.133C109.411 94.5284 105.184 93.1294 101.896 94.9947C100.487 95.6165 99.3911 96.8601 98.9214 97.9482H96.8862C98.6083 93.4403 103.775 91.1086 108.158 92.8185C110.507 93.7512 112.229 95.6165 113.168 97.9482Z",
    fill: "#15112D"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M83.6573 79.9161L92.1113 75.4082",
    stroke: "#15112D",
    strokeWidth: 2.2179,
    strokeMiterlimit: 10
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M127.258 80.0716L118.804 75.4082",
    stroke: "#15112D",
    strokeWidth: 2.2179,
    strokeMiterlimit: 10
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M181.489 31.937C184.837 31.937 187.551 29.2229 187.551 25.8748C187.551 22.5267 184.837 19.8125 181.489 19.8125C178.14 19.8125 175.426 22.5267 175.426 25.8748C175.426 29.2229 178.14 31.937 181.489 31.937Z",
    fill: "#C8B5F8"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M190.36 8.28016C192.646 8.28016 194.5 6.42658 194.5 4.14008C194.5 1.85358 192.646 0 190.36 0C188.073 0 186.22 1.85358 186.22 4.14008C186.22 6.42658 188.073 8.28016 190.36 8.28016Z",
    fill: "#C8B5F8"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M40.43 31.7899C42.7165 31.7899 44.5701 29.9364 44.5701 27.6498C44.5701 25.3633 42.7165 23.5098 40.43 23.5098C38.1435 23.5098 36.2899 25.3633 36.2899 27.6498C36.2899 29.9364 38.1435 31.7899 40.43 31.7899Z",
    fill: "#C8B5F8"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M15.1459 111.634C19.3923 111.634 22.8346 108.192 22.8346 103.946C22.8346 99.6992 19.3923 96.2568 15.1459 96.2568C10.8996 96.2568 7.4572 99.6992 7.4572 103.946C7.4572 108.192 10.8996 111.634 15.1459 111.634Z",
    fill: "#C8B5F8"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M162.616 116.512H141.836C140.351 116.512 139.053 115.214 139.053 113.729V100.371C139.053 98.8866 140.351 97.5879 141.836 97.5879H162.43C163.914 97.5879 165.213 98.8866 165.213 100.371V113.729C165.399 115.214 164.1 116.512 162.616 116.512Z",
    fill: "#FCDEB1"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_6109_49188",
    x: 0.0640717,
    y: 18.5479,
    width: 209.961,
    height: 159.497,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 16.2646
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 16.2646
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.396078 0 0 0 0 0.478431 0 0 0 0 0.576471 0 0 0 0.27 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_6109_49188"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_6109_49188",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter1_d_6109_49188",
    x: 12.5712,
    y: 35.5085,
    width: 62.1285,
    height: 44.832,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 2.01383
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 1.47681
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.396078 0 0 0 0 0.478431 0 0 0 0 0.576471 0 0 0 0.27 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_6109_49188"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_6109_49188",
    result: "shape"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_6109_49188",
    x1: 105.045,
    y1: 34.8125,
    x2: 105.045,
    y2: 129.251,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FDFEFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#ECF0F5"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_6109_49188",
    x1: 12.3734,
    y1: 65.3932,
    x2: 19.9562,
    y2: 33.3711,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.00217859,
    stopColor: "#F9BD63"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FCDEB1"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_6109_49188",
    x1: 74.8975,
    y1: 37.848,
    x2: 67.3147,
    y2: 69.8701,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.00217859,
    stopColor: "#F9BD63"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FCDEB1"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_6109_49188",
    x1: 56.7142,
    y1: 69.8563,
    x2: 50.2838,
    y2: 54.2148,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FCDEB1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F7AD3C"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear_6109_49188",
    x1: 29.606,
    y1: 69.8563,
    x2: 36.0365,
    y2: 54.2148,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FCDEB1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F7AD3C"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgGiftCardEmpty);
export default __webpack_public_path__ + "static/media/GiftCardEmpty.494aae2be78df57a2569f2b90ef1496f.svg";
export { ForwardRef as ReactComponent };